import { render, staticRenderFns } from "./contact-journey-steps-widget.vue?vue&type=template&id=6afc35ae&"
import script from "./contact-journey-steps-widget.vue?vue&type=script&lang=js&"
export * from "./contact-journey-steps-widget.vue?vue&type=script&lang=js&"
import style0 from "./contact-journey-steps-widget.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports